// src/pages/auth/ForgotPasswordPage.jsx
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authApi } from '@/api/services'
import { Button, Input } from '@/components/common/ui'
import toast from 'react-hot-toast'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent]   = useState(false)
  const [loading, setLoading] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await authApi.forgotPassword({ email })
      setSent(true)
    } catch { toast.error('Could not send reset link') }
    finally { setLoading(false) }
  }

  if (sent) return (
    <div className="card p-8 text-center">
      <div className="text-4xl mb-4">📧</div>
      <h1 className="font-display font-bold text-2xl mb-2">Check your inbox</h1>
      <p className="text-sm text-muted">A password reset link has been sent to <strong>{email}</strong></p>
      <Link to="/login" className="text-pink text-sm font-bold hover:underline mt-6 block">Back to Sign In</Link>
    </div>
  )

  return (
    <div className="card p-8">
      <h1 className="font-display font-bold text-2xl mb-1">Forgot password?</h1>
      <p className="text-sm text-muted mb-7">Enter your email and we'll send a reset link</p>
      <form onSubmit={submit} className="space-y-4">
        <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
        <Button type="submit" loading={loading} className="w-full justify-center py-3">Send Reset Link</Button>
      </form>
      <p className="text-center text-sm text-muted mt-5">
        <Link to="/login" className="text-pink font-bold hover:underline">Back to Sign In</Link>
      </p>
    </div>
  )
}
